import { bulkActionFactory } from '@core/async-job-data';
import { AsyncJobType } from '@core/async-job-types';
import type { BulkOfferResponse } from '@core/bulk-actions-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

import type { Ids } from './bulk-actions-http-client';

const idSelector = ({ uuid }: BulkOfferResponse) => uuid;
const { actions, namespace, reducer, selectors } = createEntityCollectionStore<BulkOfferResponse>()(
  'offer-bulk-actions',
  {
    idSelector,
    customActions: adapter => {
      const getActions = bulkActionFactory(adapter);
      return {
        ...getActions('follow', AsyncJobType.BulkOffersFollow)<Ids>(),
        ...getActions('unfollow', AsyncJobType.BulkOffersUnfollow)<Ids>(),
        ...getActions('deleteArchived', AsyncJobType.BulkOffersDeleteArchived)<Ids>(),
        ...getActions('retrieveArchived', AsyncJobType.BulkOffersRetrieveArchived)<Ids>(),
        ...getActions('enableReferrals', AsyncJobType.BulkOffersEnableReferralProgram)<Ids>(),
        ...getActions('disableReferrals', AsyncJobType.BulkOffersDisableReferralProgram)<Ids>(),
      };
    },
  },
);

const OfferBulkActions = <
  Pick<
    typeof actions,
    | 'follow'
    | 'followSuccess'
    | 'followFailed'
    | 'unfollow'
    | 'unfollowSuccess'
    | 'unfollowFailed'
    | 'deleteArchived'
    | 'deleteArchivedSuccess'
    | 'deleteArchivedFailed'
    | 'retrieveArchived'
    | 'retrieveArchivedSuccess'
    | 'retrieveArchivedFailed'
    | 'enableReferrals'
    | 'enableReferralsSuccess'
    | 'enableReferralsFailed'
    | 'disableReferrals'
    | 'disableReferralsSuccess'
    | 'disableReferralsFailed'
  >
>actions;

export {
  OfferBulkActions,
  selectors as OfferBulkSelectors,
  reducer as OfferBulkReducer,
  namespace as OfferBulkNamespace,
};
